import type { components } from '@joyful/openapi/types.gen'

import type { BadgeProps } from '../Badge'
import { Badge } from '../Badge'
import { PhoneCallStatusSchema } from '../enumSchemas'

export interface CallStatusBadgeProps extends Partial<
  Omit<BadgeProps, 'children'>
> {
  status: components['schemas']['PhoneCallStatus']
}

export function CallStatusBadge({
  status,
  ...badgeProps
}: CallStatusBadgeProps) {
  const metadata = PhoneCallStatusSchema.meta(status)
  return (
    <Badge variant={metadata.variant} {...badgeProps}>
      {metadata.title}
    </Badge>
  )
}
